import React from 'react'
import ContactBanner from '../components/ContactUs/ContactBanner'
import OurTeam from '../components/OurTeam'
import ContactForm from '../components/ContactUs/ContactForm'
import OurLocation from '../components/ContactUs/OurLocation'
import Footer from "../components/Footer";

export default function ContactUs() {
  return (
    <>
    <ContactBanner/>
    <ContactForm/>
    <OurLocation/>
    <OurTeam/>
    <Footer/>
    </>
  )
}
